// extracted by mini-css-extract-plugin
export default {"wrap":"XJ-z","subtitle":"YJ-z","contentWrap":"ZJ-z","imgWrap":"_J-z","heading":"aK-z","copy":"bK-z"};